function cookieParser(parseIt){
var match = document.cookie.match(new RegExp('(^| )' + parseIt + '=([^;]+)'));
if(match){
  return match[2]
}
}


const getTimeStamp = ()=>{

  var timestamp = changeTimezone(new Date(), 'Europe/London')
  var year = timestamp.getFullYear();
  var month = timestamp.getMonth() + 1;
  var day = timestamp.getDate();

  return year+""+ month+""+ day
}



function changeTimezone(date, d_tz) {

  // suppose the date is 12:00 UTC
  var invdate = new Date(date.toLocaleString('en-US', {
    timeZone: d_tz
  }));

  // then invdate will be 07:00 in Toronto
  // and the diff is 5 hours
  var diff = date.getTime() - invdate.getTime();

  // so 12:00 in Toronto is 17:00 UTC
  return new Date(date.getTime() - diff); // needs to substract

}

function capitalise(str){
  return `${str[0].toUpperCase()}${str.slice(1)}`;
}


const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

function datediff(first, second) {        
  return Math.abs(Math.round((second - first) / (1000 * 60 * 60 * 24)));
}

const isValidEmail = email =>
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  );

  
  const copyHash = (_id, txt, onSuccess) =>{

    navigator.clipboard.writeText(_id)
  
    if (onSuccess) {
      onSuccess(txt + ' copied!');
    } else {
      alert(txt+' copied!')
    }
  
  }

  const openReference = async (ref) => {

    //console.log(ref);

    try {

      // Fetch the JSON content of the random book file
      const response = await fetch(`${process.env.PUBLIC_URL}/Bible/${ref.book}.json`);
      const bookData = await response.json();

      const chapter = bookData.chapters[ref.chapter-1]

      //console.log("ch",ref, chapter, chapter.verses[ref.verse2 - 1])

      let verse = "";

      let num = 0;

      if(parseInt(ref.verse2) >= parseInt(ref.verse1)){

            for (let i = ref.verse1 - 1; i < ref.verse2; i++) {
                // Concatenate each verse to the string
                num++
                 let append = "";
                if(num > 1){
                  append = '<br/><br/>'
                }
                verse += append+(chapter.verses[i].verse)+". "+(chapter.verses[i].text) + ' ';
            }

        }else{

          //
        }

            //console.log(ref,verse);

            return {'title': `${ref.book} ${ref.chapter} vs ${ref.verse1} ${parseInt(ref.verse2) > parseInt(ref.verse1) ? ` - ${ref.verse2}` : ""}`, 'body': verse}


    } catch (error) {
      //console.error('Error fetching verse:', error);
      return false
    }
  };

 

  function timeAgo(dateInput) {
    if (!dateInput && dateInput !== 0) return 'just now';
    
    let date;
    try {
      // Handle different input types
      if (dateInput instanceof Date) {
        date = dateInput;
      } else if (typeof dateInput === 'number' || (typeof dateInput === 'string' && /^\d+\.?\d*$/.test(String(dateInput).trim()))) {
        // Unix timestamp (seconds) - convert to milliseconds
        // Handle both number and string numbers (including decimals)
        const timestamp = typeof dateInput === 'string' ? parseFloat(dateInput) : dateInput;
        if (isNaN(timestamp)) {
          console.warn('Invalid timestamp:', dateInput);
          return 'just now';
        }
        date = new Date(timestamp * 1000);
      } else if (typeof dateInput === 'string') {
        // Handle MySQL datetime format: "YYYY-MM-DD HH:MM:SS"
        // API returns format like "2025-11-30 16:02:30" (likely in UTC/server timezone)
        // Replace space with T and add Z to indicate UTC
        // This ensures the time is parsed as UTC, not local time
        const dateStr = dateInput.replace(' ', 'T') + 'Z';
        date = new Date(dateStr);
      } else {
        console.error('Invalid date input type:', typeof dateInput, dateInput);
        return 'just now';
      }
      
      // If parsing fails, return early
      if (isNaN(date.getTime())) {
        console.error('Invalid date:', dateInput);
        return 'just now';
      }
    } catch (e) {
      console.error('Error parsing date:', dateInput, e);
      return 'just now';
    }
    
    // Get current time (Date objects store time in UTC internally)
    const now = new Date();
    
    // Calculate the difference in seconds
    // Both dates are in UTC, so the difference is correct
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    // Define time unit constants
    const secondsInMinute = 60;
    const secondsInHour = 60 * secondsInMinute;
    const secondsInDay = 24 * secondsInHour;

    // Time difference calculations
    const days = Math.floor(diffInSeconds / secondsInDay);
    const hours = Math.floor((diffInSeconds % secondsInDay) / secondsInHour);
    const minutes = Math.floor((diffInSeconds % secondsInHour) / secondsInMinute);
    const seconds = diffInSeconds % secondsInMinute;

    // Return appropriate time string (matching native app format)
    // Show "now" for very recent messages (less than 5 seconds)
    if (diffInSeconds < 5) {
      return 'now';
    }
    
    if (days > 0) {
      if (days >= 7) {
        const weeks = Math.floor(days / 7);
        if (weeks >= 4) {
          const months = Math.floor(days / 30);
          if (months >= 12) {
            const years = Math.floor(days / 365);
            return `${years}y ago`;
          }
          return `${months}mo ago`;
        }
        return `${weeks}w ago`;
      }
      return `${days}d ago`;
    } else if (hours > 0) {
      return `${hours}h ago`;
    } else if (minutes > 0) {
      return `${minutes}m ago`;
    } else {
      return `${seconds}s ago`;
    }
  }

  
 

  const validateURL = (value) => {

    try {
        new URL(value);
        return true;
    } catch (e) {
        return false;
    }
};

 
module.exports = {
  copyHash,
  isValidEmail,
  datediff,
  numberWithCommas,
  cookieParser,
  getTimeStamp,
  changeTimezone,
  capitalise,
  openReference, 
  timeAgo,
  validateURL
}